<template>
  <a-card :bordered="false" style="height:100%;padding-bottom:200px; ">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item :label="$t('label.company')" >
              <j-dict-select-tag placeholder="请选择合公司" disabled v-decorator="['companycode']"  dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag = '0'"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.contracts')" >
              <j-dict-select-tag :placeholder="$t('label.pleaseSelectContract')" v-model="formData.concode"  dictCode="efs_md_contract,name,code" @change="searchCodes"/>
            </a-form-item>
          </a-col>
          <a-col :span="20">
            <a-form-item label="公式">
              <a-input placeholder="公式" disabled v-decorator="['formulaview']"  dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag = '0'"/>
            </a-form-item>
          </a-col>
          <a-button type="primary" size="large" @click="searchByCodes">{{$t('button.search')}}</a-button>
        </a-row>
        <div class="computed">
          <a-row>
            <p class="title">代养费计算公式</p>

            <div class="computed-box">
              <div class="computed-inner" v-if="!isTest">
                <draggable v-model="formula" force-fallback="true" handle=".mover" group="formula" @end="onEnd">
                  <a-tag class="move" :color="item.color || 'blue'" v-for="(item, index) in formula" :key="index">
                    <a-popconfirm
                      title="确认删除此项？"
                      ok-text="是"
                      cancel-text="否"
                      @confirm="confirmDel(index)"
                      @cancel="cancelDel"
                    >
                      <a-input v-if="item.value == 'input'" size="small" style="width:60px" v-model="item.value" />
                      <span v-else class="mover">{{item.label}}</span>
                    </a-popconfirm>
                  </a-tag>
                </draggable>
              </div>
              <div class="computed-inner" v-else>
                {{testList}}
              </div>
              <div class="btns">
                <a-button type="danger" size="large" @click="clearFormula">{{$t('button.clear')}}</a-button>
                <a-button type="primary" size="large" @click="saveFormula">保存</a-button>
                <a-button type="primary" size="large" @click="testFormula">{{isTest ? '返回' : '验证'}}</a-button>
              </div>
            </div>
          </a-row>
          <a-row class="controller">
            <a-col :span="18">
              <p class="title">变量</p>
              <a-button @click="addVariable(item)" size="large" :type="item.value == 'input' ? 'danger' : 'primary'" v-for="(item, index) in variableLists" :key="index">{{item.label}}</a-button>
            </a-col>
            <a-col :span="6">
              <p class="title">运算符</p>
              <a-button @click="addOperator(item)" size="large" type="primary" v-for="(item, index) in operatorLists" :key="index">{{item.label}}</a-button>
            </a-col>
          </a-row>
          <a-modal
            title="请输入数字"
            :visible="inputVisible"
            @ok="handleInputOk"
            @cancel="handleInputCancel"
          >
            <a-input type="number" v-model="dialogInput" />
          </a-modal>
        </div>
      </a-form>
    </div>

  </a-card>
</template>

<script>
import draggable from "vuedraggable"
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'
import JDictSelectTag from "@/components/dict/JDictSelectTag"
import { postAction } from '@api/manage'
import { addFormula, delFormula } from '@api/api'
import { getByCodes } from '@api/api'
import { getCompanyCodeByConCode } from '@api/api'
import { validateDuplicateValue } from '@/utils/util'
import pick from 'lodash.pick'

export default {
  name: 'FarmulaForm',
  components:{
    draggable,
    JFormContainer,
    JDate,
    JDictSelectTag,
  },
  data() {
    return {
      rules: {
        concode: [
          { validator: (rule, value, callback) =>
              validateDuplicateValue('efs_stl_formula', 'con_code', value, this.model.id, callback)}
        ]
      },
      form: this.$form.createForm(this),
      url: {
        save: "/calculation/efsStlFormula/add"
      },
      formData: {},
      // 变量数组
      variableLists: [
        {
          label: '市场价收入',
          value: 'outAmount',
        },{
          label: '合同价收入',
          value: 'conAmount',
        },{
          label: '特定饲料成本',
          value: 'specialFeedAmount',
        },{
          label: '禽苗成本',
          value: 'chickAmount',
        },{
          label: '饲料成本',
          value: 'feedAmount',
        },{
          label: '药品成本',
          value: 'drugAmount',
        },{
          label: '疫苗成本',
          value: 'vaccineAmount',
        },{
          label: '总费用',
          value: 'feeAmount',
        },{
          label: '总奖励',
          value: 'rewardAmount',
        },{
          label: '总处罚',
          value: 'punishAmount',
        },{
          label: '入雏数',
          value: 'chickQty',
        },{
          label: '出栏只数',
          value: 'outQty',
        },{
          label: '出栏重量',
          value: 'outWeight',
        },{
          label: '合同均重',
          value: 'stdWeightAvg',
        },{
          label: '单位代养费',
          value: 'maintainPrice',
        },{
          label: '单位管理费用',
          value: 'managerFeeAmount',
        },{
          label: '单位销售费用',
          value: 'salesFeeAmount',
        },{
          label: '输入数字',
          value: 'input',
        }
      ],
      // 操作数组
      operatorLists: [
        {
          label: '+',
          value: '+'
        },
        {
          label: '-',
          value: '-'
        },
        {
          label: '*',
          value: '*'
        },
        {
          label: '/',
          value: '/'
        },
        {
          label: '>',
          value: '>'
        },
        {
          label: '<',
          value: '<'
        },
        {
          label: '=',
          value: '='
        },
        {
          label: '>=',
          value: '>='
        },
        {
          label: '<=',
          value: '<='
        },
        {
          label: 'if',
          value: 'if'
        },
        {
          label: '( )',
          value: '( )'
        }
      ],
      // 公式
      formula: [],
      lastIsVariable: false,
      // 数字输入弹窗
      inputVisible: false,
      // 数字输入框
      dialogInput: '',
      testList: '',
      isTest: false,
      conCodeList:[],//合同
      currentConCode: ''
    }
  },
  methods: {
    searchByCodes() {
      let conCode = this.formData.concode
      let companyCode = this.formData.companyCode
      let formulaView = this.formData.formulaview
      let that = this
      if (conCode == undefined) {
        that.$message.error('Select Company and Contract')
      } else {
        getCompanyCodeByConCode({ conCode:this.formData.concode }).then((res) => {
          if (res != undefined) {
            this.formData.companycode = res;
            this.$nextTick(() => {
              this.form.setFieldsValue({companycode: res, })
            });
            let params =  {
              conCode:this.formData.concode,
              companyCode:res
            }
            getByCodes(params).then((res) => {
              if (res != undefined) {
                this.formData.formulaview = res.formula;
                this.$nextTick(() => {
                  this.form.setFieldsValue({formulaview: res.formula, })
                });
              } else {
                that.$message.error('No Results')
                that.loading = false
              }
            })
          } else {
            that.$message.error('No Results')
            that.loading = false
          }
        })
      }
    },
    searchCodes(value) {
      alert(value),
        getByCodes(params).then((res)=>{
          if(res.success && res!=null){
            that.$message.success(res.message)
          }else {
            that.$message.error(res.message)
          }
        })
    },
    // 点击变量
    addVariable(item) {
      if (this.lastIsVariable == false) {
        if (item.value == 'input') {
          this.inputVisible = true
          return false;
        }
        item.color = "blue";
        this.getResult(item);
        this.lastIsVariable = true;
      }
    },
    // 点击运算符
    addOperator(item) {
      if (this.lastIsVariable) {
        item.color = "orange";
        if (item.value == "( )") {
          let list = ["\u0028", "\u0029"]
          list.map(item => {
            this.getResult({
              label: item,
              value: item,
              color: "orange"
            });
          })
        } else if (item.value == "if") {
          let list = ["if", "\u0028", "\u0029", "\u007B", "\u007D", "else", "\u007B", "\u007D"]
          list.map(item => {
            this.getResult({
              label: item,
              value: item,
              color: "orange"
            });
          })
        } else {
          this.getResult(item);
        }
      }
      this.lastIsVariable = false;
    },
    // 获取公式并展示
    getResult(item) {
      this.formula.push(item);
      console.log(item)
    },
    // 拖放结束
    onEnd() {
      // console.log('this.formulaCalculation',this.formula)
    },
    // 确认删除
    confirmDel(i) {
      this.formula.splice(i, 1);
    },
    // 取消删除
    cancelDel() {

    },
    // 确认数字填入
    handleInputOk() {
      let item = {
        label: this.dialogInput,
        value: this.dialogInput,
        color: 'blue'
      }
      this.getResult(item);
      this.inputVisible = false
      this.dialogInput = ''
      this.lastIsVariable = true;
    },
    // 取消数字填入
    handleInputCancel() {
      this.inputVisible = false
      this.dialogInput = ''
    },
    // 验证公式|提交
    testFormula() {
      this.isTest = !this.isTest
      let testList = ''
      this.formula.map(item => {

        testList += item.value
      })
      this.testList = testList

    },
    saveFormula() {
      let testList = ''
      this.formula.map(item => {
        testList += item.value
      })
      let that = this;
      that.loading = true;
      if (this.formula.length == 0 || this.formData.concode == undefined) {
        that.$message.error('No Formula or Contract')
      } else {
        getCompanyCodeByConCode({ conCode:this.formData.concode }).then((getCompanyCodeByConCodeRes) => {
          if (getCompanyCodeByConCodeRes != undefined) {
            let params =  {
              conCode:this.formData.concode,
              companyCode:getCompanyCodeByConCodeRes
            }
            getByCodes(params).then((getByCodesRes) => {
              if (getByCodesRes.formula == undefined) {
                let params =  {
                  formula:testList,
                  conCode:this.formData.concode,
                  companyCode:getCompanyCodeByConCodeRes
                }
                addFormula(params).then((res) => {
                  if (res.success) {
                    that.$message.success(res.message)
                    that.loading = false
                  } else {
                    that.$message.error(res.message)
                    that.loading = false
                  }
                })
              } else {
                delFormula({id:getByCodesRes.id}).then((res) => {})
                let params =  {
                  formula:testList,
                  conCode:this.formData.concode,
                  companyCode:getCompanyCodeByConCodeRes
                }
                addFormula(params).then((res) => {
                  if (res.success) {
                    that.$message.success("Updated")
                    that.loading = false
                  } else {
                    that.$message.error(res.message)
                    that.loading = false
                  }
                })
              }
            })

          } else {
            that.$message.error('Error Finding Company by Contract')
            that.loading = false
          }
        })

      }
    },
    // 清空公式
    clearFormula() {
      this.formula = []
      this.testList = ''
      this.isTest = false
      this.lastIsVariable = false
    }
  }
}
</script>

<style lang="less">
.computed {
  padding: 20px;
  p.title {
    margin: 10px 0 5px;
    font-size: 20px;
  }
  .computed-box {
    position: relative;
    border: 1px solid #ccc;
    box-sizing: border-box;
    height: 300px;
    padding: 20px;
    .computed-inner {
      height: 100%;
      .move {
        height: 26px;
        line-height: 26px;
        cursor: move;
        vertical-align: top;
      }
    }
    .btns {
      position: absolute;
      right: 20px;
      bottom: 20px;
      .ant-btn {
        margin-left: 10px;
      }
    }
  }
  .controller {
    .ant-col {
      padding: 6px 20px 20px;
      border: 1px solid #ccc;
      border-top: none;
      box-sizing: border-box;
      &:nth-of-type(1) {
        border-right: none;
      }
      .ant-btn {
        margin: 4px 10px 4px 0;
      }
    }
  }
}
</style>
